import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import InvoicesListView from "./list";
import InvoiceInformationView from "./single";
import useAccessLevels from "../../../../../hooks/use-access-levels";


const InvoiceViews = ({allowPayments}) => {
    const operatorAccessLevels = useAccessLevels();

    return (
        <Switch>
            {
                operatorAccessLevels.packages.sales.invoiceInformation &&
                <Route path={[
                    routes.customer.sales.invoices.single,
                    routes.customer.accounting.invoices.single,
                ]} exact>
                    <InvoiceInformationView allowPayments={allowPayments}/>
                </Route>
            }
            {
                operatorAccessLevels.packages.sales.invoicesList &&
                <Route path={[
                    routes.customer.sales.invoices.base,
                    routes.customer.accounting.invoices.base,
                    routes.sales.invoices,
                    routes.accounting.invoices,
                ]} exact>
                    <InvoicesListView allowPayments={allowPayments}/>
                </Route>
            }
            <Redirect to={routes.sales.invoices.concat(routes.error.serverErrorForSection)}/>
        </Switch>
    );
};

export default InvoiceViews;
